<template>
	<div class="prodictImageswapFooter"> 
	<!-- v-model="slide"  -->
	<b-carousel id="carousel-1" :interval="intervalSlider" controls indicators   img-width="100%" img-height="645px"    :no-hover-pause=true >
					 <b-carousel-slide  >
							<template #img >
								<b-row style="color: #ffff;">
									<b-col class="marginBot" cols="6" lg="2"  md="6" sm="6">
										<div class="footer-title text-left">
											<h4>Learn about Us</h4>
										</div>
										<div class="footer-content fullist">
											<ul class="footerLinkul">
												<li><b-link href="/about">About us</b-link></li>
												<li><b-link href="/careers">Careers</b-link></li>
												<li><b-link href="/contactus">Contact us</b-link></li>
												<li><b-link href="/videos">Watch & Buy</b-link></li>
												<li><b-link href="/training">Training Registration</b-link></li>
											</ul>
										</div>
									</b-col>
									<b-col class="marginBot p-0" cols="6" lg="2" md="6"  sm="6">
										<div class="footer-title text-left">
											<h4>Earn With Us</h4>
										</div>
										<div class="footer-content fullist">
											<ul class="footerLinkul ">
												<li><b-link href="/marketing/seller">Sell on Alluraa</b-link></li>
												<li><b-link :href="'/marketing/'+$root.INFLUENCER">Become an {{$root.INFLUENCER_TEXT}}</b-link></li>
												<li><b-link href="/marketings">Advertise on Alluraa</b-link></li>
												<li><b-link href="/faq">FAQs</b-link></li>
												<li><b-link href="/offers">Explore Offers</b-link></li>
											</ul>
										</div>
									</b-col>
								</b-row>
							</template>
					  </b-carousel-slide>
					 <b-carousel-slide  >
							<template #img >
								<b-row style="color: #ffff;">
									<b-col class="marginBot" cols="6" lg="2"  md="6" sm="6">
										<div class="footer-title text-left">
											<h4>Top Categories</h4>
										</div>
										<div class="footer-content fullist">
											<ul class="footerLinkul">
												<li><b-link href="/women" >Women's Fashion</b-link></li>
												<li><b-link href="/men">Men's Fashion</b-link></li>
												<li><b-link href="/cosmetics/makeup">Makeup</b-link></li>
												<li><b-link href="/cosmetics/skin-care">Skin Care</b-link></li>                          
												<li><b-link href="/home-essentials/arts-and-crafts" >Arts and Crafts</b-link></li>                          
											</ul>
										</div>
									</b-col>
									<b-col class="marginBot" cols="6" lg="2" md="6"  sm="6">
										<div class="footer-title text-left">
											<h4>Contact Us</h4>
											</div>
											<div class="footer-content fullist">                        
												<ul class="footerLinkul">
													<li>Appack Technologies LLP <br />House No. 163, 1st Floor, Block – CB, Ring Road, Naraina, New Delhi – 110028</li>
																				
												</ul>
											</div>
											<!--<b-row>
												<b-col cols="1"><b-link href="mailto:contactus@alluraa.com" style="color:#fff;
    font-size: 14px;">contactus@alluraa.com</b-link></b-col>
											</b-row> -->
									</b-col>
								</b-row>
							</template>
					  </b-carousel-slide>
					  <!--<b-carousel-slide >
						<template #img >
						<b-link href="/brand/badahair-products">
						  <img
							
							width="100%"
							max-height="280"
							:src="$root.MEDIAPATH+'banners/BADAHAIR-1.jpg'"
							alt="image slot"
							
							:class="[{'fullImage' : fullWidthImage}]" @click="fullWidthImage = !fullWidthImage"
						  />
						  </b-link>
						</template>
					  </b-carousel-slide>
					  
					  <b-carousel-slide >
						<template #img >
						<b-link href="/brand/badahair-products">
						  <img
							
							width="100%"
							max-height="280"
							:src="$root.MEDIAPATH+'banners/BADAHAIR-3.jpg'"
							alt="image slot"
							
							:class="[{'fullImage' : fullWidthImage}]" @click="fullWidthImage = !fullWidthImage"
						  />
						  </b-link>
						</template>
					  </b-carousel-slide> -->
					  
					  
						
                     
					
                       <!-- <b-carousel-slide :img-src="$root.MEDIAPATH+'banners/17a0e514-2928-418d-9050-f6e661a1ccab.jpg'"></b-carousel-slide>
						<b-carousel-slide :img-src="$root.MEDIAPATH+'banners/45c0461d-fb33-4a9f-b9fb-107d36c85153.jpg'"></b-carousel-slide>  -->
                    </b-carousel>
	
	
	
		
   </div>
    
</template>

<script>
//import AddtocartButton from "@/components/addtocartButton.vue";
export default {
  name: 'Quickview',
  props: {
    galleryimages: { type: Array }
  },
  components: {
  //"addtocart-button": AddtocartButton,
  },
  mounted(){
    //this.heading = "Related Products";
  },
  computed: {
   
  },
  data() {
  
    return{
		//thumbnailProps: { blank: false, fluidGrow: true, width: 360, height: 400,class: 'm1' },
		intervalSlider:4000,
		 fullWidthImage: false,
		 bannerItems:[		 
		 'KKT1193.jpg',
		 'KKT22669M.jpg',
		 'KKT2675.jpg',
		 'KKT2547.jpg',
		 'KKT2267G.jpg',
		 'KKT2492.jpg',
		 'KKT2489.jpg',
		 'KKT2268W.jpg',
		'KKT2266P.jpg',
		'KKT2550.jpg',],
		 mainProps: {
          center: true,
          fluidGrow: true,
          blank: true,
          blankColor: '#fff',
          width: '800',
          height: '800',
         // class: 'my-5'
        }
    }
  },
  methods:{
		zoomMe(event){
		
		console.log('Zoom me'+event.width);
		}
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.prodictImageswapFooter{
		margin-bottom: 27px;
		height:auto !important;
		.carousel-indicators {
		
		
			bottom: -35px;
			z-index: unset;
			width: 100%;
			margin-left: 0px;
			li{
				    width: 6px;
					height: 6px;
					 border-radius: 100%;
					 background-color: #000;
					 z-index: 0;
					 margin: 0px 6px;
					 border: 1px solid #fff;
				/* &:focus{ border:2px solid red;
				}*/
			}
			
			
			.expand { width:23em;/* height: 25em;*/ border:1px solid red;}
				
			
		}
		.footerLinkul{
			a{color:#fff;}
		}
		.carousel-control-next{ display:none;}
		.carousel-control-prev{ display:none;}
			 
		.carousel-item{
				padding: 4px;
				/*box-shadow: 0 2px 3px 0 rgb(0 0 0 / 10%);
				transition: box-shadow linear 0.2s;
				
				 background-color: #fff;*/
				:hover{
				
				}
			}
		
		.fullImage {
			  width: 200%;
			  height: auto;
			}
	
		/*.swiper-wrapper{
			.padding:0px;
			.swiper-slide{
				padding:0px;
				background-color: unset;
			}
		}
		.productigDisplay{
			max-width: 100%;
			height: 400px;
		} */
		
		.img-fluid{
		    max-width: 100%;
			height: auto !important;
		}
		.w-100{
			width: auto !important;
		}
	}
	/*.swiper-priceinfo{
				min-height: 45px;
	}
			  
  .swiper-button-lock {
	display:block !important;
  } */

</style>
